/* global ga b:true */

/**
 * pushes a 'page view' to google
 * @description by convention, all 'jg analytics' providers
 * (that is, all analytics*.js files in this dir) should share
 * the same interface.
 * @param {string} pageName - name of current page
 */
export const trackPageView = pageName => {
	if (window.ga) {
		ga('set', 'page', pageName);
		ga('send', 'pageview');
	}
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/analytics/analytics-google.js